module.exports = __webpack_public_path__ + "img/money-icon.a3ce8f48.svg";